import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classes from './SignIn.module.css';
import Logo from 'assets/images/logos/logo-dark-backgrounds.svg';
import AuthForm from 'containers/Auth/AuthForm/AuthForm';
import { checkValidity, updateObject } from 'shared/utility';
import * as actions from 'store/actions';

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      controls: {
        email: {
          elementType: 'input',
          elementConfig: {
            type: 'email',
            placeholder: 'Email Address',
          },
          value: '',
          validation: {
            required: true,
            isEmail: true,
            validationError: '',
          },
          valid: false,
          touched: false,
        },
        password: {
          elementType: 'input',
          elementConfig: {
            type: 'password',
            placeholder: 'Password',
          },
          value: '',
          validation: {
            required: true,
            minLength: 7,
            validationError: '',
          },
          valid: false,
          touched: false,
        },
      },
      formIsValid: false,
    };
  }

  inputChangedHandler = (event) => {
    // This conditional statement checking to make sure input field object exists has been added due to a one off crash where
    // this.state.controls[event.target.type] somehow returned as null.
    if (this.state.controls[event.target.type]) {
      const updatedControls = updateObject(this.state.controls, {
        [event.target.type]: updateObject(this.state.controls[event.target.type], {
          value: event.target.value,
          valid: checkValidity(event.target.value, this.state.controls[event.target.type].validation, this.state.controls.password.value),
          touched: true,
        }),
      });

      let formIsValid = true;
      for (const inputIdentifier in updatedControls) {
        formIsValid = updatedControls[inputIdentifier].valid && formIsValid;
      }

      this.setState({ controls: updatedControls, formIsValid });
    }
  };

  submitHandler = (event) => {
    event.preventDefault();
    console.log('SignIn - submitHandler');
    this.props.onSignIn(this.state.controls.email.value, this.state.controls.password.value, null);
  };

  render = () => {
    const showServerSwitched = !!(this.props.selectedServer && process.env.NODE_ENV !== this.props.selectedServer.DefaultFor.toLowerCase());
    return (
      <div className={classes.SignInContainer}>
        <div className={classes.AuthLogo}>
          <img src={Logo} alt="riza" />
        </div>
        <AuthForm
          isAuthenticated={this.props.isAuthenticated}
          profileCreated={this.props.profileCreated}
          controls={this.state.controls}
          disabled={!this.state.formIsValid}
          submit={this.submitHandler}
          changed={this.inputChangedHandler}
          formType="SignIn"
          authRedirect="/life-shared/timeline"
          buttonLabel="Sign In"
        />
        {showServerSwitched === true ? (
          <h3 className={classes.ServerSwitchedAlert}>Alert: You've switched to the following server: {this.props.selectedServer.Name}</h3>
        ) : null}
        <Link to="/sign-up">Create New Account</Link>
        <Link to="/request-password-reset">Forgot Password?</Link>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated !== false,
    profileCreated: state.user.signedInAs.FirstName.length > 0,
    selectedServer: state.app.selectedServer,
    signedInAs: state.user.signedInAs,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSignIn: (email, password, tempPass) => dispatch(actions.signIn(email, password, tempPass)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
